/******************************************************************************
 *
 * Copyright (c) 2019-2024 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Kunal Pandey' <kunal.pandey@wakencode.com>, November 2024
 *
 *****************************************************************************/

import { createContext, useContext, useState } from "react";

export const Authcontext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  return <Authcontext.Provider value={{ token, setToken }}>{children}</Authcontext.Provider>;
};

export const useAuth = () => useContext(Authcontext);
